import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MarketingLayout from "@/components/layout/MarketingLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Drivers from "@/pages/Drivers";
import Partners from "@/pages/Partners";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsAndConditions from "@/pages/TermsAndConditions";
import RefundPolicy from "@/pages/RefundPolicy";
import Press from "@/pages/Press";
import Pros from "@/pages/Pros";
import DeleteAccount from "@/pages/DeleteAccount";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProtectedAdminRoute from "@/components/admin/ProtectedAdminRoute";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            {/* Marketing site */}
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/drivers" element={<Drivers />} />
              <Route path="/pros" element={<Pros />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/press" element={<Press />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              {/* Legacy redirects */}
              <Route path="/legal/privacy" element={<Navigate to="/privacy-policy" replace />} />
              <Route path="/legal/terms" element={<Navigate to="/terms-and-conditions" replace />} />
              <Route path="/legal/refund" element={<Navigate to="/refund-policy" replace />} />
              <Route path="/legal" element={<Navigate to="/privacy-policy" replace />} />
              <Route path="/legal/:slug" element={<Navigate to="/privacy-policy" replace />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              }
            />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0F1014",
            color: "#ffffff",
            border: "1px solid rgba(255,255,255,0.1)",
          },
        }}
      />
    </div>
  );
}

export default App;
